import { trigger, state, animate, style, transition } from '@angular/animations';

export function dropdownAnimation() {
  return trigger('dropdownAnimation', [
    state('closed', style({
      opacity: 0,
      height: 0,
      transform: 'translateY(-10px)',
    })),
    state('open', style({
      opacity: 1,
      height: '*',
      transform: 'translateY(0)',
    })),
    transition('closed <=> open', [
      animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')
    ]),
  ]);
}
